import { render, staticRenderFns } from "./SocialPage.vue?vue&type=template&id=1a65e29e&"
import script from "./SocialPage.vue?vue&type=script&lang=js&"
export * from "./SocialPage.vue?vue&type=script&lang=js&"
import style0 from "./SocialPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports